// extracted by mini-css-extract-plugin
module.exports = {"vidWrapper":"VideoPlayer_vidWrapper_3nEOC"};